import React, { useEffect, useRef } from 'react'
import Formsy from 'formsy-react'
import clsx from 'clsx'
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  TextField,
  InputAdornment,
  Checkbox,
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import CancelButton from 'app/components/buttons/CancelButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'
import { Search } from '@material-ui/icons'
import DataTable from 'app/components/table/DataTable'
import { useChecked } from 'app/components/table/useChecked'
import { withFirstColumn } from '../../../../components/table/TableColumn'
import * as R from 'ramda'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
export default ({
  state,
  classes,
  toggleDialogs,
  handleAddSubscriber,
  selectedSubgroup,
  isOpen,
  checkedItems,
  isLoading,
}) => {
  const {
    state: dataTable,
    toggleSelect,
    toggleSelectAll,
    onPageChange,
    onPageSizeChange,
    onSearchData,
    setInitailDate,
  } = useChecked(state)
  const mobileClasses = useMobileStyle()
  const { formatMessage } = useIntl()
  const formRef = useRef(null)

  const isEmptyCheckIds = R.compose(
    R.equals(0),
    R.length,
    R.when(R.isNil, []),
    R.prop('checkedItems'),
  )(dataTable)

  const sortArray = (data) => {
    if (R.isNil(data)) {
      return false
    }
    return R.sort((a, b) => {
      return a - b
    }, data)
  }

  const isPristine = R.equals(
    sortArray(R.prop('checkedItems', dataTable)),
    sortArray(checkedItems),
  )
  const columns = [
    withFirstColumn({
      Header: () => (
        <div>
          <Checkbox
            color="secondary"
            onClick={(event) => {
              event.stopPropagation()
            }}
            onChange={R.compose(toggleSelectAll, R.path(['target', 'checked']))}
            checked={R.prop('isCheckAll', dataTable)}
            indeterminate={R.prop('indeterminate', dataTable)}
          />
        </div>
      ),
      Cell: (row) => {
        return (
          <Checkbox
            onClick={(event) => {
              event.stopPropagation()
            }}
            color="secondary"
            checked={R.includes(
              row.value.id,
              R.prop('checkedItems', dataTable),
            )}
            onChange={() =>
              R.compose(toggleSelect, R.path(['value', 'id']))(row)
            }
          />
        )
      },
      className: clsx('sticky fixBackground'),
      headerClassName: clsx('sticky'),
    }),
    {
      Header: formatMessage({ id: 'firstName.label' }),
      accessor: 'displayFirstName',
      id: 'firstName',
      filterable: true,
      width: 120,
    },
    {
      Header: formatMessage({ id: 'lastName.label' }),
      accessor: 'displayLastName',
      id: 'lastName',
      filterable: true,
      width: 120,
    },
  ]

  useEffect(() => {
    if (isOpen) {
      setInitailDate({
        checkedItems: checkedItems,
        membersList: [...R.prop('membersList', state)],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
  return (
    <ResponsiveDialog
      fullWidth={false}
      isFullScreen={false}
      open={isOpen}
      className={clsx(
        classes.groupDialogTwo,
        classes.groupDialogStyleOne,
        mobileClasses.lessPaddingMobile,
      )}
    >
      <DialogTitle className={classes.groupDialogTitleWrap}>
        <FormattedMessage
          id="group.details.dialogs.addSubscriber"
          values={{
            name: R.prop('name', selectedSubgroup),
          }}
        />
      </DialogTitle>

      <DialogContent>
        <Formsy
          onSubmit={() =>
            handleAddSubscriber([...R.prop('checkedItems', dataTable)])
          }
          ref={formRef}
          className="flex flex-col justify-center w-full"
          id="addGroup"
        >
          {!(
            !R.length([R.prop('membersList', dataTable)]) &&
            !R.prop('searchText', dataTable)
          ) && (
            <FormControl className={classes.margin}>
              <TextField
                id="standard-search"
                margin="dense"
                placeholder="Search field"
                value={R.prop('searchText', dataTable)}
                onChange={(e) =>
                  onSearchData({
                    text: e.target.value,
                    membersList: [...R.prop('membersList', state)],
                  })
                }
                type="search"
                variant="outlined"
                autoFocus
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          )}

          {R.length([R.prop('membersList', dataTable)]) && (
            <DataTable
              data={R.prop('membersList', dataTable)}
              total={R.length(R.prop('membersList', dataTable))}
              columns={columns}
              showPagination={true}
              sortable={true}
              resizable={true}
              minRows={1}
              defaultPageSize={10}
              className={classes.addSubscriberTable}
              isLoading={isLoading}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          )}
          {!R.length([R.prop('membersList', dataTable)]) &&
            R.prop('searchText', dataTable) && (
              <div className={classes.addSubscriberSearchNoData}>
                <p>{formatMessage({ id: 'group.notSubscribers' })}</p>
              </div>
            )}
          {!R.length([R.prop('membersList', dataTable)]) &&
            !R.prop('searchText', dataTable) && (
              <div className={classes.addSubscriberNoData}>
                <p>{formatMessage({ id: 'group.notSubscribersToAdd' })}</p>
              </div>
            )}
          {!(
            !R.length([R.prop('membersList', dataTable)]) &&
            !R.prop('searchText', dataTable)
          ) && (
            <span className={classes.addSubscriberHint}>
              <FormattedMessage
                id="group.details.dialogs.selectedSubscriber"
                values={{
                  count: R.length(R.prop('checkedItems', dataTable)),
                }}
              />
            </span>
          )}
        </Formsy>
      </DialogContent>
      {!(
        !R.length([R.prop('membersList', dataTable)]) &&
        !R.prop('searchText', dataTable)
      ) && (
        <DialogActions className={classes.renameActionBtns}>
          <CancelButton
            onClick={() => {
              toggleDialogs(false)
            }}
            className={mobileClasses.modalBtn}
          />
          <PrimaryButton
            disabled={isEmptyCheckIds || isPristine || isLoading}
            type="submit"
            color="primary"
            className={clsx(
              classes.actionBtn,
              classes.groupActionBtns,
              mobileClasses.modalBtn,
            )}
            isLoading={isLoading}
            variant="contained"
            form="addGroup"
          >
            <FormattedMessage id="action.add" />
          </PrimaryButton>
        </DialogActions>
      )}
    </ResponsiveDialog>
  )
}
